import { useRef, useLayoutEffect } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const ComingHome = () => {
  const root = useRef(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: root.current,
          start: 'top top',
          end: '+=220%',
          pin: true,
          scrub: 1.4,
        },
      });
      tl.fromTo('.ch-title', { letterSpacing: '-0.02em', opacity: 0.9 }, { letterSpacing: '0.18em', opacity: 1, duration: 3, ease: 'none' }, 0)
        .to('.ch-bg', { opacity: 1, scale: 1, duration: 3, ease: 'none' }, 0.4)
        .to('.ch-overlay', { opacity: 0.55, duration: 2.5, ease: 'none' }, 0.6)
        .to('.ch-title', { color: '#FAFAF8', duration: 2, ease: 'none' }, 1)
        .fromTo('.ch-complete', { opacity: 0, y: 40, filter: 'blur(8px)' }, { opacity: 1, y: 0, filter: 'blur(0px)', duration: 2, ease: 'power2.out' }, 2.4);
    }, root);
    return () => ctx.revert();
  }, []);

  return (
    <section ref={root} data-testid="coming-home-section" className="relative h-[100svh] overflow-hidden bg-[#F5F0E8]">
      <div
        className="ch-bg absolute inset-0 opacity-0 scale-110 will-change-transform"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1448375240586-882707db888b?auto=format&fit=crop&w=1800&q=75)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
      <div className="ch-overlay absolute inset-0 bg-[#1A4D38] opacity-0" />
      <div className="relative h-full flex flex-col items-center justify-center text-center px-6">
        <h2 className="ch-title font-serif-display font-light text-5xl sm:text-7xl lg:text-[8vw] leading-none text-[#2C2C2A] will-change-transform">
          Coming Home
        </h2>
        <p className="ch-complete font-serif-display italic font-light text-3xl sm:text-5xl lg:text-6xl text-[#F5F0E8] mt-8 md:mt-12" style={{ opacity: 0 }}>
          to Yourself.
        </p>
      </div>
    </section>
  );
};

export default ComingHome;
